import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import { catchError } from '../../helpers/catch-error-client'
import ReactLoading from 'react-loading';
import {validateEmail,validatePhone} from '../../helpers/common';




const CaseManagerInformation = ({ work_order, onWorkOrderChange, onWorkOrderCreated, is_loading = true }) => {
    const navigate = useNavigate();   
    const [caseManager, setCaseManager] = useState(null);
    const [caseManagerAdd, setCaseManagerAdd] = useState({
        case_manager_id: "",
        case_manager_client_id: "",
        case_manager_first_name: "",
        case_manager_last_name: "",
        case_manager_email: "",
        case_manager_phone: "",
        case_manager_opt_in: 1,
        can_create_wo: 1,
    });

    const [caseManagersList, setCaseManagersList] = useState(null);
 
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [isSearchCaseManagerModalOpen, setIsSearchCaseManagerModalOpen] = useState(false);
    const [editCaseManagerMode, setEditCaseManagerMode] = useState(false);
    const [addCaseManagerMode, setAddCaseManagerMode] = useState(false);
   

    useEffect(() => {
      
            getCaseManagers();
            if (work_order?.case_manager_id > 0) {
                getCaseManager(work_order?.case_manager_id);
            }
        
      

    }, [work_order?.case_manager_id]);




    const getCaseManager = async (case_manager_id) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-case-manager-by-id/" + case_manager_id , {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setCaseManager(response?.data?.case_manager);

            } else {

                Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getCaseManagers = async () => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-case-managers/" , {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setCaseManagersList(response?.data?.case_managers);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }

    const saveCaseManager = async (e) => {

        setIsBtn(true);
       
        const { case_manager_first_name, case_manager_last_name, case_manager_email, case_manager_phone } = caseManagerAdd;
        if ( !case_manager_first_name || !case_manager_last_name || !case_manager_email || !validateEmail(case_manager_email) || !validatePhone(case_manager_phone) ) {

        
            setInputError(true);
            setIsBtn(false);

        } else {

            var case_manager_info = {
                work_order_id: work_order.work_order_id,
                case_manager_first_name: caseManagerAdd.case_manager_first_name,
                case_manager_last_name: caseManagerAdd.case_manager_last_name,
                case_manager_email: caseManagerAdd.case_manager_email,
                case_manager_phone: caseManagerAdd.case_manager_phone,
                case_manager_opt_in: caseManagerAdd.case_manager_opt_in,
                can_create_wo: caseManagerAdd.can_create_wo,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-case-manager", case_manager_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    caseManager.case_manager_id = response?.data?.case_manager_id;
                    setCaseManager(case_manager_info);
                    setAddCaseManagerMode(false);
                    setEditCaseManagerMode(false);

                    addCaseManagerToWorkOrder(response?.data?.case_manager_id);
                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }




    const updateCaseManager = async (e) => {

        setIsBtn(true);
     
        const { case_manager_first_name, case_manager_last_name, case_manager_email, case_manager_phone } = caseManager;
        if ( !case_manager_first_name || !case_manager_last_name || !case_manager_email || !validateEmail(case_manager_email) || !validatePhone(case_manager_phone) ) {

                  setInputError(true);
            setIsBtn(false);

        } else {

            var case_manager_info = {
                case_manager_id: caseManager.case_manager_id,
                work_order_id: work_order.work_order_id,
                case_manager_first_name: caseManager.case_manager_first_name,
                case_manager_last_name: caseManager.case_manager_last_name,
                case_manager_email: caseManager.case_manager_email,
                case_manager_phone: caseManager.case_manager_phone,
                case_manager_opt_in: caseManager.case_manager_opt_in,
                can_create_wo: caseManager.can_create_wo,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/update-case-manager", case_manager_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setCaseManager(case_manager_info);
                    setAddCaseManagerMode(false);
                    setEditCaseManagerMode(false);

                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }



    const addCaseManagerToWorkOrder = async (case_manager_id) => {

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-case-manager-to-work-order",
            {
                work_order_id: work_order?.work_order_id, case_manager_id: case_manager_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    onWorkOrderChange({ case_manager_id: case_manager_id });
                    setCaseManager(response?.data?.case_manager);

                } else {
                    Swal.fire({ icon: "error", title: "Case Manager", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });




    }





    

       const resetCaseManagerAdd = () => {


        setCaseManagerAdd({
            case_manager_id: "",
            case_manager_client_id: "",
            case_manager_first_name: "",
            case_manager_last_name: "",
            case_manager_email: "",
            case_manager_phone: "",
            case_manager_opt_in: 1,
            can_create_wo: 1,
        })

    }




    return (
        <>
            <div className="card card-form" >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0 py-3" >
                        <div className="col-md-5 col-sm-12 ">  <h6 className=" fw-bold text-dark m-0 ">CASE MANAGER INFORMATION

                        </h6></div>
                        <div className="col-md-7 text-end ">


        {addCaseManagerMode ?
            <>
                <button onClick={() => saveCaseManager()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                <button onClick={() => setAddCaseManagerMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL SAVE</button>

            </>
            :
            <>
                {editCaseManagerMode ?
                    <>
                        <button onClick={() => updateCaseManager()} className="btn btn-sm  btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                        <button onClick={() => setEditCaseManagerMode(false)} className="btn btn-sm  btn-sm btn-warning me-1 " type="button">CANCEL UPDATE</button>
                    </>

                    :
                    <>
                        <button onClick={() => { resetCaseManagerAdd(); setAddCaseManagerMode(true) }} className="btn btn-sm btn-sm btn-success me-1 " type="button">NEW</button>
                        <button onClick={() => { setIsSearchCaseManagerModalOpen(true); }} className="btn btn-sm  btn-sm btn-warning me-1 " type="button">ASSIGN EXISTING</button>
                        {(work_order?.case_manager_id > 0) &&
                            <button onClick={() => setEditCaseManagerMode(true)} className="btn btn-sm  btn-sm  btn-danger me-1 " type="button">EDIT</button>
                        }
                    </>
                }
            </>
        }






</div>
                      
                    </div>

                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :
                        <>
                            {(work_order?.client_id > 0 ) &&
                                <form id="frm_client" >

                                    <div className="row " >

                                        <div className="col-xl-12 col-lg-12" >
                                            <div className="" >
                                                
                                                    
                                                        {(addCaseManagerMode) &&
                                                            <>

                                                                <div className="row px-3 py-3 gx-2 ">
                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_first_name">First Name*</label>
                                                                        <input name="case_manager_first_name" id="case_manager_first_name" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_first_name} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_first_name: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError &&
                                                                            (!caseManagerAdd.case_manager_first_name || !(caseManagerAdd.case_manager_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                <span className="text-danger">Enter valid first name</span>
                                                                            )}

                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_last_name">Last Name*</label>
                                                                        <input name="case_manager_last_name" id="case_manager_last_name" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_last_name} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_last_name: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError &&
                                                                            (!caseManagerAdd.case_manager_last_name || !(caseManagerAdd.case_manager_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                <span className="text-danger">Enter valid last name</span>
                                                                            )}

                                                                    </div>

                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_email">Email*</label>
                                                                        <input name="case_manager_email" id="case_manager_email" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_email} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_email: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError &&
                                                                            (!caseManagerAdd.case_manager_email || !validateEmail(caseManagerAdd.case_manager_email)) && (
                                                                                <span className="text-danger">Enter valid email</span>
                                                                            )}

                                                                    </div>

                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_phone">PHONE</label>
                                                                        <input name="case_manager_phone" id="case_manager_phone" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_phone} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_phone: e.target.value })
                                                                            }
                                                                        />
                                                                              {inputError && !validatePhone(caseManagerAdd?.case_manager_phone) && (
                                                                    <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                               )}


                                                                    </div>

                                                                    


                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_opt_in">Email Opt-In:</label>
                                                                        <div className="form-control border-2 border-dark px-1">
                                                                        <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
                                                                            onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 1 })} checked={(caseManagerAdd.case_manager_opt_in == 1) ? "true" : ""} /> Yes
                                                                        <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
                                                                            onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 0 })} checked={(caseManagerAdd.case_manager_opt_in == 0) ? "true" : ""} /> No
                                                                  </div>
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="can_create_wo">Can Create Case:</label>
                                                                        <div className="form-control border-2 border-dark px-1">
                                                                        <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
                                                                            onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 1 })} checked={(caseManagerAdd.can_create_wo == 1) ? "true" : ""} /> Yes
                                                                        <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
                                                                            onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 0 })} checked={(caseManagerAdd.can_create_wo == 0) ? "true" : ""} /> No
                                                                  </div>
                                                                    </div>
                                                                </div>

                                                            </>

                                                               }
                                                           
                                                                {(editCaseManagerMode) &&
                                                                    <>

                                                                        <div className="row px-3 py-3 gx-2 ">
                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_first_name">First Name*</label>
                                                                                <input name="case_manager_first_name" id="case_manager_first_name" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_first_name} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_first_name: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_first_name || !(caseManager.case_manager_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                        <span className="text-danger">Enter valid first name</span>
                                                                                    )}

                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_last_name">Last Name*</label>
                                                                                <input name="case_manager_last_name" id="case_manager_last_name" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_last_name} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_last_name: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_last_name || !(caseManager.case_manager_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                        <span className="text-danger">Enter valid last name</span>
                                                                                    )}

                                                                            </div>

                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_email">Email*</label>
                                                                                <input name="case_manager_email" id="case_manager_email" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_email} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_email: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_email || !validateEmail(caseManager.case_manager_email) ) && (
                                                                                        <span className="text-danger">Enter valid email</span>
                                                                                    )}

                                                                            </div>

                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_phone">PHONE</label>
                                                                                <input name="case_manager_phone" id="case_manager_phone" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_phone} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_phone: e.target.value })
                                                                                    }
                                                                                />

{inputError && !validatePhone(caseManager?.case_manager_phone) && (
                                                                    <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                               )}

                                                                            </div>

                                                                           


                                                                           <div className="col-2">
                                                                                <label htmlFor="case_manager_opt_in">Email Opt-In:</label>
                                                                                <div className="form-control border-2 border-dark px-1">
                                                                                <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
                                                                                    onClick={() => setCaseManager({ ...caseManager, case_manager_opt_in: 1 })} checked={(caseManager.case_manager_opt_in == 1) ? "true" : ""} /> Yes
                                                                                <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
                                                                                    onClick={() => setCaseManager({ ...caseManager, case_manager_opt_in: 0 })} checked={(caseManager.case_manager_opt_in == 0) ? "true" : ""} /> No
                                                                           </div>
                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label htmlFor="can_create_wo">Can Create Case:</label>
                                                                                <div className="form-control border-2 border-dark px-1">
                                                                                <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
                                                                                    onClick={() => setCaseManager({ ...caseManager, can_create_wo: 1 })} checked={(caseManager.can_create_wo == 1) ? "true" : ""} /> Yes
                                                                                <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
                                                                                    onClick={() => setCaseManager({ ...caseManager, can_create_wo: 0 })} checked={(caseManager.can_create_wo == 0) ? "true" : ""} /> No
                                                                            </div>
                                                                            </div>
                                                                        </div>
                                                                    </>

                                                            }
                                                              
                                                                        {(caseManager && work_order?.case_manager_id > 0) ?
                                                                            <>

                                                                                <div className="row px-3 py-3 gx-2 ">
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_first_name">First Name</label><br/>
                                                                                        <label className="field-info">{caseManager.case_manager_first_name}</label>


                                                                                    </div>
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_last_name">Last Name</label><br/>
                                                                                        <label className="field-info">{caseManager.case_manager_last_name}</label>

                                                                                    </div>

                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_email">Email</label><br/>
                                                                                        <label className="field-info tt-none">{caseManager.case_manager_email}</label>


                                                                                    </div>

                                                                            
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_phone">PHONE</label><br/>
                                                                                        <label className="field-info">{caseManager.case_manager_phone ? caseManager.case_manager_phone : ""}</label>
                                                                                    </div>

                                                                                    

                                                                              
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_fax">EMAIL OPT-IN: </label><br/>
                                                                                        <label className="field-info" >{(caseManager.case_manager_opt_in == 1) ? "Yes" : "No"}</label>

                                                                                    </div>


                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_fax">CAN CREATE CASE: </label><br/>
                                                                                        <label className="field-info" >{(caseManager.can_create_wo == 1) ? "Yes" : "No"}</label>

                                                                                    </div>


                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <div className="row px-3 py-2 gx-2 ">
                                                                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                                                                    <h6>
                                                                                        Case Manager not assigned yet.
                                                                                    </h6>

                                                                                </div>
                                                                            </div>
                                                                        }
                                                              
                                                        
                                               
                                            </div>
                                        </div>


                                    </div>

                                </form>


                            }
                        </>
                    }
                </div>



            </div>




            <Modal animation={false}
                show={isSearchCaseManagerModalOpen}
                onHide={() => { setIsSearchCaseManagerModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-case-manager-modal"
            >
                <Modal.Header>
                    <h3 className="m-0 p-0">CASE MANAGERS</h3>
                    <button onClick={() => { setIsSearchCaseManagerModalOpen(false); }} type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content ">


                        <div className="row pb-4">

                            <div className="col-md-12 col-sm-12">

                                {!caseManagersList ?
                                    <label>No case manager found</label>
                                    :
                                    <>
                                        <ul className="list-group">
                                            <li key={999}
                                                onClick={e => {

                                                    addCaseManagerToWorkOrder(null);
                                                    setIsSearchCaseManagerModalOpen(false);
                                                }}
                                                className={!work_order?.case_manager_id ? "active list-group-item" : "list-group-item"}>


                                                <input key="0" name="case_manager" className="form-check-input mx-3" type="checkbox"
                                                    checked={!work_order?.case_manager_id ? true : false}
                                                    onChange={e => {
                                                        addCaseManagerToWorkOrder(null);
                                                        setIsSearchCaseManagerModalOpen(false);
                                                    }} />
                                                None, Remove Case Manager
                                            </li>
                                            {caseManagersList && caseManagersList?.map((cm, index) => (

                                                <li key={index} className={work_order?.case_manager_id == cm.case_manager_id ? "active list-group-item" : "list-group-item"}
                                                    onClick={e => {

                                                        addCaseManagerToWorkOrder(cm.case_manager_id);
                                                        setIsSearchCaseManagerModalOpen(false);
                                                    }}
                                                >


                                                    <input key={cm.case_manager_id} name="case_manager" className="form-check-input mx-3" type="checkbox"
                                                        checked={work_order?.case_manager_id == cm.case_manager_id ? true : false} value={cm.case_manager_id}
                                                        onClick={e => {

                                                            addCaseManagerToWorkOrder(cm.case_manager_id);
                                                            setIsSearchCaseManagerModalOpen(false);
                                                        }}
                                                    />
                                                    {cm.case_manager_last_name + " " + cm.case_manager_first_name}
                                                </li>

                                            ))}
                                        </ul>
                                    </>


                                }


                            </div>


                        </div>



                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="container text-center">

                        <button onClick={() => { setIsSearchCaseManagerModalOpen(false); }} className="btn btn-warning">Cancel</button>
                    </div>

                </Modal.Footer>
            </Modal>




        </>

    );
};

export default CaseManagerInformation;